import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatSnackBar, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { QuizService } from 'src/app/services/quiz.service';

@Component({
  selector: 'app-add-quiz-modal',
  templateUrl: './add-quiz-modal.component.html',
  styleUrls: ['./add-quiz-modal.component.scss']
})
export class AddQuizModalComponent implements OnInit {
  quizForm: FormGroup;
  loader: boolean = false;
  quizFormError: boolean = false
  constructor(public _quizService: QuizService, public _snackbar: MatSnackBar, public dialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.dialogRef.disableClose = false
  }
  get quizFormErrorStatus() { return this.quizForm.controls }
  ngOnInit() {
    console.log("what is the data=========", this.data);

    this.createForm()
  }

  createForm() {
    this.quizForm = new FormGroup({
      quizName: new FormControl('', Validators.required),
      quizDescription: new FormControl(''),
      hbsPath: new FormControl('')
    })
  }

  submit() {
    if (!this.quizForm.invalid){
      this.loader = true;
      console.log("SUBMIT QUIZ", this.quizForm.value);
      let obj = {
        quizName: this.quizForm.value.quizName,
        quizDescription: this.quizForm.value.quizDescription,
        materialId: this.data.materialId,
        hbsPath: this.quizForm.value.hbsPath,
      }

      this._quizService.addQuiz(obj).subscribe(quizAdded => {
        console.log("QUIZ", quizAdded)
        this.loader = false;
        this.dialogRef.close(quizAdded)
      })

    }
  }

}
